import ImageView from "./ImageView.vue";
import { Image } from "@tiptap/extension-image";
import { VueNodeViewRenderer } from "@tiptap/vue-3";

export default Image.extend({
  selectable: false,
  addNodeView() {
    return VueNodeViewRenderer(ImageView as any);
  },
});
